module.exports = "https://static.wmbcdn.com/uniweb/images/5767ea0a04d948c0b5c23221ceb3ec48.svg";